export const TYPES = {
  USE_CASE_DECORATOR: Symbol.for('USE_CASE_DECORATOR'),
  LOGGER: Symbol.for('LOGGER'),
  STATE: Symbol.for('STATE'),
  WINDOW: Symbol.for('WINDOW'),
  STATE_MANAGER: Symbol.for('STATE_MANAGER'),
  BASE_STATE_MANAGER: Symbol.for('BASE_STATE_MANAGER'),
  APPLICATION: Symbol.for('APPLICATION'),
  VUE: Symbol.for('VUE'),
  ROUTER: Symbol.for('ROUTER'),

  TODO_COMMAND_CREATE: Symbol.for('TODO_COMMAND_CREATE'),
  TODOS_QUERY_GET: Symbol.for('TODOS_QUERY_GET'),
  TODO_COMMAND_COMPLETE: Symbol.for('TODO_COMMAND_COMPLETE'),

  RUNNER: Symbol.for('RUNNER'),
  LOGGER_LINK: Symbol.for('LOGGER_LINK'),
  EXECUTOR_LINK: Symbol.for('EXECUTOR_LINK'),
  TODO_REPOSITORY: Symbol.for('TODO_REPOSITORY'),

  LOCATION_COMMAND_CREATE: Symbol.for('LOCATION_COMMAND_CREATE'),
  LOCATION_REPOSITORY: Symbol.for('LOCATION_REPOSITORY'),
  LOCATIONS_QUERY_GET: Symbol.for('LOCATIONS_QUERY_GET')
}
